import {
  injectSlice,
  createSlice,
  PayloadAction,
  createAction,
} from '@bonanza-social/toolkit/state';

import { SmarticoMessage, SmarticoState } from './smartico.types';

export const smarticoSocketConnected = createAction('smartico/socketConnected');

const initialState: SmarticoState = {
  popups: [],
};

const smartico = createSlice({
  name: 'smartico',
  initialState,
  reducers: {
    setPopupUrl(state, action: PayloadAction<string>) {
      state.popupUrl = action.payload;
    },
    addPopup(state, action: PayloadAction<SmarticoMessage>) {
      state.popups.push(action.payload);
    },
    closePopup(state) {
      state.popups.shift();
    },
  },
});

const withSmartico = injectSlice({
  reducerPath: 'smartico',
  reducer: smartico.reducer,
});

export const { setPopupUrl, addPopup, closePopup } = smartico.actions;

export const selectPopupUrl = withSmartico.selector(
  (state) => state.smartico.popupUrl,
);
export const selectPopup = withSmartico.selector((state) =>
  state.app.popupsEnabled ? state.smartico.popups[0] : undefined,
);

declare global {
  interface LazyLoadedSlices {
    smartico: ReturnType<typeof smartico.reducer>;
  }
}
